import { Typography } from '@mui/material';
import type { FC } from 'react';
import Box from '@mui/material/Box';

const NoAccessField: FC<{ text?: string }> = ({ text }) => {
  return (
    <>
      <Box sx={t => ({
        display: 'flex',
        alignItems: 'center',
        px: 2,
        borderRadius: 1.25,
        border: `1px solid ${t.palette.grey[400]}`,
        height: 40,
        width: '100%',
      })}>
        <Typography variant={'body2'} sx={t => ({ color: t.palette.action.disabled })}>
          {text ?? 'No access to view'}
        </Typography>
      </Box>
    </>
  );
};


export default NoAccessField;